import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tooltip)?_c(VTooltip,_vm._b({attrs:{"bottom":"","min-width":"300","max-width":"300"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VIcon,_vm._g({attrs:{"small":"","color":_vm.color ? _vm.color : 'grey lighten-1'}},on),[_vm._v(_vm._s(_vm.icon ? _vm.icon : "fas fa-question-circle"))])]}}],null,false,495500830)},'v-tooltip',_vm.$attrs,false),[_c('span',[_vm._v(_vm._s(_vm.tooltip))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }